import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaEnvelope } from "react-icons/fa";

export default function SendEmailNode({ data, selected }) {
  return (
    <div className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[220px] transition-shadow ${selected ? "border-blue-500 shadow-md" : "border-surface-border"}`}>
      <Handle type="target" position={Position.Top} className="!w-3 !h-3 !bg-blue-500 !border-2 !border-white" />
      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px]" style={{ background: "linear-gradient(135deg, #2563eb, #3b82f6)" }}>
        <FaEnvelope size={10} className="text-white" />
        <span className="text-xs font-semibold text-white">Send Email</span>
      </div>
      <div className="px-3 py-2.5">
        {data.subject ? (
          <>
            <p className="text-xs text-ink-primary font-medium line-clamp-1">{data.subject}</p>
            {data.to && <p className="text-2xs text-ink-muted mt-0.5">To: {data.to}</p>}
          </>
        ) : (
          <p className="text-xs text-ink-muted italic">Configure email...</p>
        )}
        {data.htmlBody && <p className="text-2xs text-blue-500 mt-1">HTML email</p>}
      </div>
      <Handle type="source" position={Position.Bottom} className="!w-3 !h-3 !bg-blue-500 !border-2 !border-white" />
    </div>
  );
}
